import React from 'react';

const ShippingDelivery = () => {
    return (
        <>
            <style>{`
                body {
                    background-color: #121212;
                    color: #e0e0e0;
                    font-family: 'Inter', sans-serif;
                }

                .legal-container {
                    background-color: #1f1f1f;
                    padding: 2rem;
                    border-radius: 0.5rem;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
                    max-width: 900px;
                    margin: 2rem auto;
                    color: #a5a6ad;
                    font-size: 0.95rem;
                    line-height: 1.6;
                }

                .company-name {
                    font-size: 1.2rem;
                    font-weight: 500;
                    color: #9e9e9e;
                    margin-bottom: 0.5rem;
                    display: block;
                }
                
                .legal-container h2 {
                    font-size: 2rem;
                    font-weight: 700;
                    color: #ffffff;
                    border-bottom: 2px solid #333;
                    padding-bottom: 0.75rem;
                    margin-bottom: 2rem;
                }
                
                .legal-container h3 {
                    font-size: 1.5rem;
                    font-weight: 600;
                    color: #f0f0f0;
                    margin-top: 2.5rem;
                    margin-bottom: 1rem;
                }
                
                .legal-container p {
                    margin-bottom: 1.2rem;
                    color: #b0b0b0;
                }
                
                .legal-container ul {
                    list-style-type: none;
                    padding-left: 0;
                    margin-bottom: 1rem;
                }
                
                .legal-container li {
                    position: relative;
                    padding-left: 1.5rem;
                    margin-bottom: 0.75rem;
                    color: #b0b0b0;
                }
                
                .legal-container li::before {
                    content: '•';
                    color: #4a90e2;
                    position: absolute;
                    left: 0;
                    font-size: 1.2rem;
                    line-height: 1;
                }
                
                .legal-container strong {
                    color: #ffffff;
                    font-weight: 600;
                }
                
                .legal-container .highlight {
                    background-color: #2a2a31;
                    padding: 1.5rem;
                    border-radius: 0.5rem;
                    border-left: 4px solid #4a90e2;
                    margin: 2rem 0;
                }
                
                .legal-container .highlight p {
                    color: #d0d0d0;
                    margin: 0;
                }
            `}</style>
            <div className="legal-container">
                <span className="company-name">CommunityofHubs</span>
                <h2>Shipping & Delivery Policy</h2>
                <p><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</p>

                <h3>Digital Products</h3>
                <p>
                    All digital products, courses, and services are delivered immediately upon successful payment. You will receive a confirmation email with access instructions within minutes of completing your purchase.
                </p>

                <h3>Physical Products</h3>
                <p>
                    For physical products, we offer the following shipping options:
                </p>
                <ul>
                    <li><strong>Standard Shipping:</strong> 5-7 business days</li>
                    <li><strong>Express Shipping:</strong> 2-3 business days</li>
                    <li><strong>International Shipping:</strong> 10-15 business days</li>
                </ul>

                <h3>Order Processing</h3>
                <p>
                    Orders are processed within 24-48 hours on business days (Monday-Friday). Orders placed on weekends or holidays will be processed on the next business day. You will receive a confirmation email once your order has been processed.
                </p>

                <h3>Shipping Costs</h3>
                <p>
                    Shipping costs are calculated at checkout based on your location and selected shipping method. Free shipping may be available for eligible orders over a certain amount.
                </p>

                <div className="highlight">
                    <p>
                        <strong>International Orders:</strong> International orders may incur customs fees, import duties, and taxes, which are the responsibility of the customer. Please check with your local customs office for more information.
                    </p>
                </div>

                <h3>Tracking Information</h3>
                <p>
                    Once shipped, a tracking number will be provided via email to monitor delivery status. You can track your order directly on our website or through the carrier's tracking portal.
                </p>

                <h3>Delivery Issues</h3>
                <p>
                    For delivery issues, please contact support within 14 days of the expected delivery date. We will investigate the issue and work to resolve it as quickly as possible.
                </p>

                <h3>Contact Information</h3>
                <p>
                    For shipping inquiries, please contact us at:<br />
                    <strong>Email:</strong> e.communityhubs@gmail.com<br />
                    <strong>Phone:</strong> +91 9850083751<br />
                    <strong>Address:</strong> Rajdhani Complex, Office no. 409, 4th Floor, Pune - Satara Rd, Near Shankar Maharaj Math, Pune, Maharashtra
                </p>
            </div>
        </>
    );
};

export default ShippingDelivery;